import { classNames } from "primereact/utils";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import React from "react";
import { Checkbox } from "primereact/checkbox";
import {
  MultiSelectController,
  RadioButtonController,
  InputTagController,
} from "./MultiSelectController";
import { EmailControl } from "./emailControl";
import { RoleNames } from "./roleNames";
import { StorageConfig } from "./storageConfig/storageConfig";
import { Password } from "primereact/password";
import { Divider } from "primereact/divider";
import { ConfirmPassword } from "./password/password";
import { AppCheckbox } from "./checkbox";
import { FileAccessibility } from "./fileAccessibility/fileAccessibility";
import { EmailSender } from "./emailSender";
import { UpdateDocController } from "../upload/Upload";
export function getFormControl(
  field,
  fieldState,
  controlConfig = { type: "" },
  form,
  requiredSymbol,
  setIsUploadComplete,
  existingDocInfo
) {
  const header = <div className="rc_passwordstrength_head">Password strength</div>;
  const footer = (
    <>
      
      <div className="mt-1 rc_must_contain">
        <p>Must contain:</p>
      <ul className="pl-2 ml-2 mt-0 line-height-3">
        <li>At least one alphabet</li>
        <li>At least one numeric</li>
        <li>At least one special character</li>
        <li>Minimum 8 characters</li>
      </ul>
      </div>
    </>
  );

  switch (controlConfig.type) {
    case "confirmPassword":
      return (
        <ConfirmPassword
          inputForm={form}
          className={classNames({ "p-invalid": fieldState.invalid })}
          field={field}
          fieldState={fieldState}
          controlConfig={controlConfig}
        />
      );
    case "password":
      return (
        <Password
          id={field.name}
          {...field}
          autoFocus
          {...controlConfig.htmlAttributes}
          className={classNames({ "p-invalid": fieldState.invalid })}
          feedback={true}
          header={header}
          footer={footer}
          toggleMask
        />
      );
    case "passwordConfirm":
      return (
        <Password
          id={field.name}
          {...field}
          autoFocus
          {...controlConfig.htmlAttributes}
          className={classNames({ "p-invalid": fieldState.invalid })}
          feedback={false}
          toggleMask
        />
      );
    case "signinPassword":
      return (
        <Password
          id={field.name}
          {...field}
          autoFocus
          {...controlConfig.htmlAttributes}
          className={classNames({ "p-invalid": fieldState.invalid })}
          feedback={false}
          toggleMask
        />
      );

    case "textbox":
      return (
        <InputText
          disabled={!controlConfig.editable}
          autoComplete="off"
          id={field.name}
          {...field}
          autoFocus={controlConfig.htmlAttributes.autofocus}
          {...controlConfig.htmlAttributes}
          className={classNames({ "p-invalid": fieldState.invalid })}
        />
      );
    case "email":
      return (
        <EmailControl
          form={form}
          rules={controlConfig.rules}
          id={field.name}
          field={field}
          htmlAttributes={controlConfig.htmlAttributes}
          className={classNames({ "p-invalid": fieldState.invalid })}
        />
      );

    case "textarea":
      return (
        <InputTextarea
          disabled={!controlConfig.editable}
          autoComplete="off"
          rows={5}
          cols={30}
          id={field.name}
          {...field}
          {...controlConfig.htmlAttributes}
          autoFocus
          className={classNames({ "p-invalid": fieldState.invalid })}
        />
      );
      // created new type for emailSender checkbox
      case "emailSender":
        return (
          <EmailSender
            inputForm={form}
            className={classNames({ "p-invalid": fieldState.invalid })}
            field={field}
            fieldState={fieldState}
            controlConfig={controlConfig}
          />
        );
    case "dropdown": {
      const options = controlConfig?.options || [];
      const optionLabel =
        Array.isArray(controlConfig.options) &&
        controlConfig.options.length > 0 &&
        (controlConfig.options[0].label
          ? "label"
          : controlConfig.options[0].key
          ? "key"
          : undefined);
      const fn_createOption = (option) => {
        if (typeof option === "object") {
          let op = {};
          op = { key: option.key, val: option.val };
          if (optionLabel === "label") op.label = option.label;
          return op;
        } else if (typeof option === "string") {
          return option;
        }
        return "";
      };
      const preparedOptions = options.map((x) => {
        return fn_createOption(x);
      });

      const defaultValue = options.find((x) => x.selected === true);
      if (defaultValue && field.value === undefined) {
        field.value = fn_createOption(defaultValue);
        field.onChange(field.value);
      }
      return (
        <Dropdown
          disabled={!controlConfig.editable}
          dropdownIcon="fa fa-caret-down"
          id={field.name}
          className={classNames({ "p-invalid": fieldState.invalid })}
          {...controlConfig.htmlAttributes}
          optionLabel={optionLabel}
          value={field.value}
          appendTo={"self"}
          onChange={(e) => field.onChange(e.value)}
          options={preparedOptions}
        />
      );
    }
    case "checkbox":
      return <AppCheckbox field={field} fieldState={fieldState} controlConfig={controlConfig}/>;
    // <Checkbox inputId={field.name} onChange={(e) => field.onChange(e.checked)} checked={field.value || false} defaultChecked={false} className={classNames({ 'p-invalid': fieldState.invalid })} />
    case "multicheckbox":
      return (
        <MultiSelectController
          requiredSymbol={requiredSymbol}
          className={classNames({ "p-invalid": fieldState.invalid })}
          field={field}
          fieldState={fieldState}
          controlConfig={controlConfig}
        />
      );
    case "radiobtn":
      return (
        <RadioButtonController
          className={classNames({ "p-invalid": fieldState.invalid })}
          field={field}
          fieldState={fieldState}
          controlConfig={controlConfig}
        />
      );
    case "inputtag":
      return (
        <InputTagController
          disabled={!controlConfig.editable}
          className={classNames({ "p-invalid": fieldState.invalid })}
          field={field}
          fieldState={fieldState}
          {...controlConfig.htmlAttributes}
          controlConfig={controlConfig}
        />
      );
    case "roles":
      return (
        <RoleNames
          className={classNames({ "p-invalid": fieldState.invalid })}
          field={field}
          fieldState={fieldState}
          controlConfig={controlConfig}
        />
      );
    case "storageConfig":
      return (
        <StorageConfig
          inputForm={form}
          type="Azure"
          className={classNames({ "p-invalid": fieldState.invalid })}
          field={field}
          fieldState={fieldState}
          controlConfig={controlConfig}
        />
      );
    case "groupRoles" :
      return (
        <FileAccessibility
          inputForm={form}
          field={field}
          classNames={classNames}
          fieldState={fieldState}
          controlConfig={controlConfig}
        />
      );
    case "upload":
      return (
        <UpdateDocController
          className={classNames({ "p-invalid": fieldState.invalid })}
          field={field}
          fieldState={fieldState}
          {...controlConfig.htmlAttributes}
          controlConfig={controlConfig}
          setIsUploadComplete={setIsUploadComplete}
          existingDocInfo={existingDocInfo}
        />
      );
    default:
      return <></>;
  }
}

const controlClasses = {
  dropdown: "col-md-6",
  inputtag: "col-md-12",
  upload: "col-md-12",
  textbox: "col-md-6",
  email: "col-md-6",
  roles: "col-md-6",
  radiobtn: "col-md-6",
  confirmPassword: "col-md-6",
  checkbox: "col-md-6",
  groupRoles:"col-md-6",
};

export function getControlClasses(controlConfig = { type: "" }) {
  return controlClasses[controlConfig.type] || "";
}
